import { render, staticRenderFns } from "./MesaTable.vue?vue&type=template&id=0ee3d1bd"
import script from "./MesaTable.vue?vue&type=script&lang=js"
export * from "./MesaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports